import { IApplicationState } from '../../types/redux';

export const selectPageType = (state: IApplicationState) => state.calculator.pageType;
